import { DataBox, createDataBox, createDataBoxDefault } from 'app/common/data-box-store'
import { ItemType } from 'app/common/ui-next/plain-selector'
import { ComplexChangeAction } from 'app/common/types/food/schools/complexes/history'


export type ComplexHistoryOperations = Array<ItemType>

class ComplexHistoryOperationsFilterDataBox extends DataBox<ComplexHistoryOperations> {}

export const defaultComplexHistoryOperations: ComplexHistoryOperations = []
export const complexHistoryOperationsFilter = createDataBox(
  'complexHistoryOperationsFilter',
  defaultComplexHistoryOperations,
  ComplexHistoryOperationsFilterDataBox,
)

export const defaultComplexHistoryOperationsData = () => [
  { id: String(ComplexChangeAction.Create), title: 'Создание комплекта' },
  { id: String(ComplexChangeAction.Archive), title: 'Перемещение в архив' },
  { id: String(ComplexChangeAction.Restore), title: 'Восстановление из архива' },
  { id: String(ComplexChangeAction.Price), title: 'Изменение цены' },
  { id: String(ComplexChangeAction.Composition), title: 'Изменение состава' },
  { id: String(ComplexChangeAction.Setting), title: 'Изменение настройки' },
]

export const defaultComplexHistoryOperationsSelection: Array<string> = []
export const complexHistoryOperationsFilterSelection = createDataBoxDefault<Array<string>>(
  'complexHistoryOperationsFilterSelection',
  defaultComplexHistoryOperationsSelection,
)
